
class VideoPlayer {
  constructor(element) {
    this.$element = element
    this.$player = element.querySelector('.player')
    this.player = false
    this.videoId = this.getId()
    this.loadApi()

    this.$playBtn = element.querySelector('button')
    this.$poster = element.querySelector('.poster')

    if (this.$playBtn){
      this.$playBtn.addEventListener('click', this.play.bind(this))
    }
  }

  getId() {
    let url = this.$element.dataset.youtubeUrl
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    var match = url.match(regExp)
    if (match && match[2].length == 11) {
      return match[2]
    } else {
      return false
    }
  }

  loadApi() {
    // loads the youtbe IFrame Player API code asynchronously.
    var tag = document.createElement('script')
    tag.src = '//www.youtube.com/player_api'
    var firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    window.addEventListener(
      'youtube-api-ready',
      this.createVideoPlayer.bind(this),
    )
    window.onYouTubePlayerAPIReady = this.apiReady.bind(this)
    window.addEventListener(
      'youtube-playing', 
      this.onVideoPlaying.bind(this),
    )
  }

  apiReady() {
    window.dispatchEvent(new Event('youtube-api-ready'))
  }

  createVideoPlayer() {
    if (this.videoId) {
      this.$player.id = `player-${this.videoId}`

      if (this.player == false) {
        try {
          this.player = new YT.Player(`player-${this.videoId}`, {
            playerVars: { autoplay: 0, controls: 1, rel: 0 },
            videoId: this.videoId,
            events: {
              onReady: this.onPlayerReady.bind(this),
              onStateChange: this.onVideoPlayerStateChange.bind(this),
            },
          })
        } catch (err) {
          window.console && console.log(err)
        }
      }
    }
  }

  play() {
    if (this.player){
      this.player.playVideo()

      if (this.$poster){
        this.$poster.classList.add('hidden')
      }
    }

    this.isStarted = true
  }

  onPlayerReady() {}

  onVideoPlayerStateChange(event) {
    if (event.data == 1){
      window.dispatchEvent(new CustomEvent('youtube-playing', { detail: { id: this.videoId } }))
    }

  }

  onVideoPlaying(event){
    if (event.detail.id != this.videoId){
      this.player.pauseVideo()
    }

  }


}

const videoBlocks = document.querySelectorAll(
  'section.section-video .video-player',
)

videoBlocks.forEach(function (element) {
  let videoPlayer = new VideoPlayer(element)
})
